/*
 * The "Poruči odmah" buy-now button (#rsi_buy_now_button) is React-rendered
 * by Releasit and sets its own inline styles on the icon/text nodes at
 * render time. CSS !important rules in releasit-override.css lost that
 * fight (confirmed 2026-09-19: font-size stayed visibly smaller than the
 * theme's native "Dodaj u korpu" button despite a matching !important rule),
 * most likely because Releasit re-applies inline styles after our stylesheet
 * is applied. Directly overwriting the inline style via JS always wins,
 * since it's the same declaration being overwritten, not a cascade fight —
 * and a MutationObserver re-applies it if Releasit re-renders the button.
 */
(function () {
  function fixButton(btn) {
    if (!btn) return;

    // Re-applied on every mutation (not skipped after first fix) because
    // Releasit's React re-render can reset inline styles on the same node
    // in place (e.g. on a quantity/cart change) without replacing it.
    var innerFlex = btn.querySelector(':scope > div');
    if (!innerFlex) return;

    innerFlex.style.setProperty('justify-content', 'center', 'important');
    innerFlex.style.setProperty('align-items', 'center', 'important');
    innerFlex.style.setProperty('gap', '8px', 'important');

    var icon = btn.querySelector('svg');
    if (icon) {
      icon.style.setProperty('margin-inline', '0', 'important');
    }

    var textEl = innerFlex.querySelector('div:last-child');
    if (textEl && textEl !== icon) {
      textEl.style.setProperty('flex', '0 1 auto', 'important');
      textEl.style.setProperty('text-align', 'center', 'important');
      textEl.style.setProperty('font-size', '1.6rem', 'important');
      textEl.style.setProperty('font-weight', '700', 'important');
      textEl.style.setProperty('font-family', 'var(--font-body-family)', 'important');
      textEl.style.setProperty('letter-spacing', '0.1rem', 'important');
    }
  }

  function fixAll() {
    document.querySelectorAll('#rsi_buy_now_button, [id^="rsi_buy_now_button"]').forEach(fixButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixAll);
  } else {
    fixAll();
  }

  var observer = new MutationObserver(function () {
    fixAll();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
